import { FC, ReactNode } from "react";
import ButtonText from "./styles/ButtonText.styled";
import LoadingSpinner from "./styles/LoadingSpinner.styled";
import ConfirmButton from "../ConfirmButton.styled";

interface SubmitButtonProps {
  onClick?: () => void;
  children: ReactNode;
  isLoading?: boolean;
}

const SubmitButton: FC<SubmitButtonProps> = ({
  onClick,
  children,
  isLoading,
}) => {
  return (
    <ConfirmButton onClick={onClick}>
      <LoadingSpinner isLoading={isLoading} />
      <ButtonText isLoading={isLoading}>{children}</ButtonText>
    </ConfirmButton>
  );
};

export default SubmitButton;
